/* ============================================================
   ALIOUR THEME JS — original code for ALIUOR (aliuor.com)
   Vanilla JS, no dependencies.
   ============================================================ */
(function () {
  'use strict';

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  /* ---------- Money formatting ---------- */
  function formatMoney(cents) {
    const format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    const parts = value.split('.');
    const withThousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withThousands + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withThousands)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1]);
  }

  /* ---------- Overlay + drawer manager ---------- */
  let overlay = null;
  function getOverlay() {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'page-overlay';
      overlay.addEventListener('click', closeAllDrawers);
      document.body.appendChild(overlay);
    }
    return overlay;
  }
  function openDrawer(id) {
    const el = document.getElementById(id);
    if (!el) return;
    closeAllDrawers(null, true);
    el.classList.add('is-open');
    getOverlay().classList.add('is-open');
    document.body.classList.add('drawer-open');
    const focusable = el.querySelector('input:not([type="hidden"]), button, a');
    if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 120);
    document.dispatchEvent(new CustomEvent('drawer:open', { detail: { id } }));
  }
  function closeAllDrawers(_e, keepOverlay) {
    $$('.drawer.is-open, .modal.is-open').forEach((d) => d.classList.remove('is-open'));
    if (!keepOverlay) {
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('drawer-open');
    }
  }
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAllDrawers(); });
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.drawerOpen); }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeAllDrawers(); }
  });

  /* ---------- Menu drawer lives on <body> ----------
     Inside the sticky (transformed) header wrapper, position:fixed breaks and the
     drawer lands below the page overlay's stacking context. Relocating fixes both. */
  function relocateMenuDrawer() {
    const drawer = document.querySelector('.shopify-section .drawer--menu');
    if (!drawer) return;
    const stale = document.querySelector('body > .drawer--menu');
    if (stale && stale !== drawer) stale.remove();
    document.body.appendChild(drawer);
  }
  relocateMenuDrawer();

  /* ---------- Header: sticky state + smart sticky + transparent ---------- */
  const headerSection = $('.header-section');
  if (headerSection) {
    const onScroll = () => headerSection.classList.toggle('is-scrolled', window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  const stickyHeader = $('.header-section.is-sticky');
  if (stickyHeader) {
    const wrap = stickyHeader.closest('.shopify-section') || stickyHeader;
    wrap.style.position = 'sticky';
    wrap.style.top = '0';
    wrap.style.zIndex = '60';
    wrap.classList.add('is-smart-sticky');

    let lastY = window.scrollY;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      const delta = y - lastY;
      if (Math.abs(delta) > 4 && !document.body.classList.contains('drawer-open')) {
        if (y < 140) wrap.classList.remove('header-hidden');
        else if (delta > 0 && !wrap.matches(':hover')) wrap.classList.add('header-hidden');
        else if (delta < 0) wrap.classList.remove('header-hidden');
      }
      lastY = y;
    }, { passive: true });
  }

  /* Transparent header only makes sense over a full-bleed hero:
     pull the hero under the header, otherwise fall back to a solid header. */
  const transparentHeader = $('.header-section.header--transparent-ready');
  if (transparentHeader) {
    const firstSection = $('main .shopify-section');
    const hero = firstSection && firstSection.querySelector('.slideshow, .content-box');
    if (hero) {
      document.body.classList.add('has-transparent-header');
      const headerEl = $('.header', transparentHeader);
      const setHeaderHeight = () =>
        document.documentElement.style.setProperty('--header-h', (headerEl ? headerEl.offsetHeight : 72) + 'px');
      setHeaderHeight();
      window.addEventListener('resize', setHeaderHeight);
    } else {
      transparentHeader.classList.remove('header--transparent-ready');
    }
  }

  /* ---------- Announcement bar rotator ---------- */
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.items = $$('.announcement__item', this);
      if (this.items.length < 2) return;
      this.index = 0;
      this.autoplay = parseInt(this.dataset.autoplay || '5', 10) * 1000;
      $('.announcement__arrow--prev', this)?.addEventListener('click', () => this.go(-1));
      $('.announcement__arrow--next', this)?.addEventListener('click', () => this.go(1));
      this.start();
    }
    start() {
      clearInterval(this.timer);
      if (this.autoplay > 0) this.timer = setInterval(() => this.go(1), this.autoplay);
    }
    go(dir) {
      this.items[this.index].classList.remove('is-active');
      this.index = (this.index + dir + this.items.length) % this.items.length;
      this.items[this.index].classList.add('is-active');
      this.start();
    }
    disconnectedCallback() { clearInterval(this.timer); }
  }
  customElements.define('announcement-bar', AnnouncementBar);

  /* ---------- Slideshow: line markers + autoplay progress + pause ---------- */
  class SlideShow extends HTMLElement {
    connectedCallback() {
      this.slides = $$('.slideshow__slide', this);
      if (!this.slides.length) return;
      this.index = 0;
      this.paused = false;
      this.autoplay = parseInt(this.dataset.autoplay || '0', 10) * 1000;
      if (this.autoplay > 0) this.style.setProperty('--marker-duration', this.autoplay + 'ms');
      this.markers = $$('.slideshow__marker', this);
      this.markers.forEach((m, i) => m.addEventListener('click', () => this.go(i)));
      $('.slideshow__playpause', this)?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.classList.toggle('is-paused', this.paused);
        this.paused ? clearInterval(this.timer) : this.start();
      });
      this.start();
      this.addEventListener('pointerdown', (e) => (this.startX = e.clientX));
      this.addEventListener('pointerup', (e) => {
        if (this.startX == null) return;
        const dx = e.clientX - this.startX;
        if (Math.abs(dx) > 48) this.go(this.index + (dx < 0 ? 1 : -1));
        this.startX = null;
      });
    }
    start() {
      clearInterval(this.timer);
      this.restartProgress();
      if (this.autoplay > 0 && this.slides.length > 1 && !this.paused) {
        this.timer = setInterval(() => this.go(this.index + 1), this.autoplay);
      }
    }
    restartProgress() {
      const marker = this.markers[this.index];
      if (!marker) return;
      const bar = marker.querySelector('.slideshow__marker-progress');
      if (!bar) return;
      bar.style.transition = 'none';
      bar.style.width = '0';
      void bar.offsetWidth;
      bar.style.transition = '';
      bar.style.width = '';
    }
    go(i) {
      this.slides[this.index].classList.remove('is-active');
      this.markers[this.index]?.classList.remove('is-active');
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides[this.index].classList.add('is-active');
      this.markers[this.index]?.classList.add('is-active');
      this.start();
    }
    disconnectedCallback() { clearInterval(this.timer); }
  }
  customElements.define('slide-show', SlideShow);

  /* ---------- Featured collections tabs ---------- */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-fc-tab]');
    if (!tab) return;
    const root = tab.closest('featured-collections');
    $$('[data-fc-tab]', root).forEach((t) => {
      const on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    $$('[data-fc-panel]', root).forEach((p) => {
      p.hidden = p.dataset.fcPanel !== tab.dataset.fcTab;
    });
  });

  /* ---------- Carousel arrows ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;
    const target = document.getElementById(btn.dataset.carouselPrev || btn.dataset.carouselNext);
    if (!target) return;
    const item = target.querySelector(':scope > *');
    const step = item ? item.getBoundingClientRect().width + 16 : target.clientWidth * 0.8;
    const dir = btn.hasAttribute('data-carousel-prev') ? -1 : 1;
    const rtl = document.documentElement.dir === 'rtl' ? -1 : 1;
    target.scrollBy({ left: step * dir * rtl, behavior: 'smooth' });
  });

  /* ---------- Marquee: duplicate track for seamless loop ---------- */
  $$('.marquee').forEach((mq) => {
    const track = $('.marquee__track', mq);
    if (!track) return;
    const clone = () => {
      while (mq.scrollWidth < window.innerWidth * 2.2 && mq.children.length < 12) {
        mq.appendChild(track.cloneNode(true));
      }
    };
    clone();
  });

  /* ---------- Reveal on scroll ---------- */
  if (document.body.classList.contains('anim-on') && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-inview'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal, .reveal-scale').forEach((el) => io.observe(el));
    $$('[data-stagger]').forEach((wrap) => $$(':scope > *', wrap).forEach((c, i) => c.style.setProperty('--i', i)));
  } else {
    $$('.reveal, .reveal-scale').forEach((el) => el.classList.add('is-inview'));
  }

  /* ---------- Reading text: word-by-word scroll reveal ---------- */
  $$('.reading-text[data-split]').forEach((el) => {
    const words = el.textContent.trim().split(/\s+/);
    el.innerHTML = words.map((w) => `<span class="word">${w}</span>`).join(' ');
    const spans = $$('.word', el);
    const onScroll = () => {
      const rect = el.getBoundingClientRect();
      const progress = Math.min(1, Math.max(0, (window.innerHeight * 0.85 - rect.top) / (rect.height + window.innerHeight * 0.35)));
      const upto = Math.floor(progress * spans.length);
      spans.forEach((s, i) => s.classList.toggle('is-read', i <= upto));
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });

  /* ---------- Links with image ---------- */
  $$('.links-image').forEach((wrap) => {
    const links = $$('.links-image__link', wrap);
    const imgs = $$('.links-image__media img', wrap);
    const activate = (link, i) => {
      links.forEach((l) => l.classList.remove('is-active'));
      imgs.forEach((im) => im.classList.remove('is-active'));
      link.classList.add('is-active');
      if (imgs[i]) imgs[i].classList.add('is-active');
    };
    links.forEach((link, i) => {
      link.addEventListener('mouseenter', () => activate(link, i));
      // Touch: first tap previews the image, second tap follows the link
      link.addEventListener('click', (e) => {
        if (window.matchMedia('(hover: none)').matches && !link.classList.contains('is-active')) {
          e.preventDefault();
          activate(link, i);
        }
      });
    });
  });

  /* ---------- Countdown ---------- */
  class CountDown extends HTMLElement {
    connectedCallback() {
      const end = new Date(this.dataset.end).getTime();
      if (isNaN(end)) return;
      const units = { d: $('[data-cd-d]', this), h: $('[data-cd-h]', this), m: $('[data-cd-m]', this), s: $('[data-cd-s]', this) };
      const tick = () => {
        let diff = Math.max(0, end - Date.now());
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const s = Math.floor(diff / 1e3);
        if (units.d) units.d.textContent = String(d).padStart(2, '0');
        if (units.h) units.h.textContent = String(h).padStart(2, '0');
        if (units.m) units.m.textContent = String(m).padStart(2, '0');
        if (units.s) units.s.textContent = String(s).padStart(2, '0');
        if (end - Date.now() <= 0) { clearInterval(this.timer); if (this.dataset.hideEnd === 'true') this.closest('.shopify-section')?.style.setProperty('display', 'none'); }
      };
      tick();
      this.timer = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  }
  customElements.define('count-down', CountDown);

  /* ---------- Before / After slider ---------- */
  $$('.before-after').forEach((ba) => {
    const set = (clientX) => {
      const rect = ba.getBoundingClientRect();
      const pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
      ba.style.setProperty('--ba-pos', pct + '%');
    };
    let dragging = false;
    ba.addEventListener('pointerdown', (e) => { dragging = true; set(e.clientX); ba.setPointerCapture(e.pointerId); });
    ba.addEventListener('pointermove', (e) => dragging && set(e.clientX));
    ba.addEventListener('pointerup', () => (dragging = false));
  });

  /* ---------- Hotspots ---------- */
  document.addEventListener('click', (e) => {
    const dot = e.target.closest('.hotspot__dot');
    if (dot) {
      const spot = dot.closest('.hotspot');
      $$('.hotspot.is-open').forEach((h) => h !== spot && h.classList.remove('is-open'));
      spot.classList.toggle('is-open');
      e.stopPropagation();
      return;
    }
    if (!e.target.closest('.hotspot__card')) $$('.hotspot.is-open').forEach((h) => h.classList.remove('is-open'));
  });

  /* ---------- Cart ---------- */
  async function refreshCartSections() {
    const ids = ['cart-drawer', 'cart-icon-bubble'];
    const res = await fetch(`${window.theme.routes.cart}?sections=${ids.join(',')}`);
    const sections = await res.json();
    if (sections['cart-drawer']) {
      const holder = document.getElementById('CartDrawer');
      if (holder) {
        const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const fresh = doc.querySelector('#CartDrawer');
        if (fresh) holder.innerHTML = fresh.innerHTML;
      }
    }
    if (sections['cart-icon-bubble']) {
      const bubble = document.getElementById('CartIconBubble');
      if (bubble) {
        const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        bubble.innerHTML = doc.querySelector('.shopify-section')?.innerHTML || '';
      }
    }
    document.dispatchEvent(new CustomEvent('cart:refreshed'));
  }

  async function addToCart(formOrData, button) {
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-disabled', 'true'); button.dataset.label = button.textContent; button.textContent = '…'; }
    try {
      const body = formOrData instanceof HTMLFormElement ? new FormData(formOrData) : formOrData;
      const res = await fetch(window.theme.routes.cartAdd + '.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Error');
      await refreshCartSections();
      if (window.theme.cartType === 'drawer' && document.getElementById('CartDrawer')) openDrawer('CartDrawer');
      else if (window.theme.cartType === 'page') window.location.href = window.theme.routes.cart;
    } catch (err) {
      alert(err.message);
    } finally {
      if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-disabled'); button.textContent = button.dataset.label; }
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-cart], form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type="submit"]'));
  });

  async function changeCartLine(key, quantity) {
    await fetch(window.theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (document.querySelector('.cart-page')) window.location.reload();
    else await refreshCartSections();
  }

  document.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); changeCartLine(remove.dataset.cartRemove, 0); return; }
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      const wrap = qtyBtn.closest('.qty');
      const input = wrap.querySelector('input');
      const next = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + parseInt(qtyBtn.dataset.qtyChange, 10));
      input.value = next;
      if (input.dataset.lineKey) changeCartLine(input.dataset.lineKey, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('.qty input[data-line-key]');
    if (input) changeCartLine(input.dataset.lineKey, Math.max(0, parseInt(input.value, 10) || 0));
    const note = e.target.closest('[data-cart-note]');
    if (note) fetch(window.theme.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  });

  /* ---------- Quick buy ---------- */
  document.addEventListener('click', (e) => {
    const qb = e.target.closest('[data-quick-buy]');
    if (!qb) return;
    e.preventDefault();
    const fd = new FormData();
    fd.append('id', qb.dataset.quickBuy);
    fd.append('quantity', '1');
    addToCart(fd, qb);
  });

  /* ---------- Product form / variant picker ---------- */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse($('[data-variants-json]', this)?.textContent || '[]');
      this.idInput = $('input[name="id"]', this);
      this.addEventListener('change', (e) => { if (e.target.matches('.variant-option input, select[data-option-select]')) this.onOptionChange(); });
    }
    currentOptions() {
      const groups = $$('[data-option-index]', this);
      return groups.map((g) => {
        const checked = g.querySelector('input:checked');
        if (checked) return checked.value;
        const sel = g.querySelector('select');
        return sel ? sel.value : null;
      });
    }
    onOptionChange() {
      const opts = this.currentOptions();
      const variant = this.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      const btn = $('[data-atc-button]', this);
      const priceEl = $('[data-price-wrap]', this);
      if (!variant) {
        if (btn) { btn.setAttribute('disabled', ''); btn.textContent = window.theme.strings.unavailable; }
        return;
      }
      if (this.idInput) this.idInput.value = variant.id;
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      if (btn) {
        if (variant.available) { btn.removeAttribute('disabled'); btn.textContent = window.theme.strings.addToCart; }
        else { btn.setAttribute('disabled', ''); btn.textContent = window.theme.strings.soldOut; }
      }
      if (priceEl) {
        let html = `<span class="price__current">${formatMoney(variant.price)}</span>`;
        if (variant.compare_at_price > variant.price) {
          html = `<span class="price__current">${formatMoney(variant.price)}</span> <s class="price__compare">${formatMoney(variant.compare_at_price)}</s>`;
          priceEl.classList.add('price--sale');
        } else priceEl.classList.remove('price--sale');
        priceEl.innerHTML = html;
      }
      const media = variant.featured_media && document.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
      if (media) media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      $$('[data-option-value-label]', this).forEach((lab) => {
        const idx = parseInt(lab.dataset.optionValueLabel, 10);
        lab.textContent = opts[idx];
      });
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant } }));
    }
  }
  customElements.define('product-form', ProductForm);

  /* ---------- Product gallery markers (mobile carousel indicator) ---------- */
  $$('[data-gallery-markers]').forEach((wrap) => {
    const gallery = document.getElementById(wrap.dataset.galleryMarkers);
    if (!gallery) return;
    const markers = $$('.product-gallery__marker', wrap);
    const setActive = (i) => markers.forEach((m, k) => m.classList.toggle('is-active', k === i));
    let ticking = false;
    gallery.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const slide = gallery.firstElementChild;
        if (slide) setActive(Math.round(gallery.scrollLeft / slide.getBoundingClientRect().width));
        ticking = false;
      });
    }, { passive: true });
    markers.forEach((m, i) => m.addEventListener('click', () => {
      const slide = gallery.children[i];
      if (slide) gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
    }));
  });

  /* ---------- Sticky add-to-cart ---------- */
  const stickyAtc = $('.sticky-atc');
  if (stickyAtc) {
    const anchor = $('[data-atc-anchor]');
    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        stickyAtc.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(anchor);
    }
    document.addEventListener('variant:change', (e) => {
      const v = e.detail.variant;
      const price = $('[data-sticky-price]', stickyAtc);
      const btn = $('[data-sticky-atc]', stickyAtc);
      if (price) price.textContent = formatMoney(v.price);
      if (btn) { btn.dataset.quickBuy = v.id; btn.toggleAttribute('disabled', !v.available); }
    });
  }

  /* ---------- Predictive search ---------- */
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = $('input[type="search"]', this);
      this.results = $('[data-predictive-results]', this);
      if (!this.input || !this.results) return;
      this.input.addEventListener('input', () => {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => this.search(), 260);
      });
    }
    async search() {
      const q = this.input.value.trim();
      if (q.length < 2) { this.results.innerHTML = ''; return; }
      try {
        const url = `${window.theme.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;
        const res = await fetch(url);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        this.results.innerHTML = doc.querySelector('#PredictiveResults')?.innerHTML || '';
      } catch (e) { /* silent */ }
    }
  }
  customElements.define('predictive-search', PredictiveSearch);

  /* ---------- Collection: facets + sorting + layout ---------- */
  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.sectionId;
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-facet-input], [data-sort-select]')) this.update();
      });
      this.addEventListener('submit', (e) => { e.preventDefault(); this.update(); });
      this.addEventListener('click', (e) => {
        const clear = e.target.closest('[data-facet-clear]');
        if (clear) {
          e.preventDefault();
          this.render(clear.getAttribute('href'));
        }
      });
    }
    update() {
      const form = $('form', this) || this.closest('form');
      const params = new URLSearchParams(new FormData(form));
      this.render(`${window.location.pathname}?${params.toString()}`);
    }
    async render(url) {
      const target = document.getElementById(`CollectionResults-${this.section}`);
      if (target) target.style.opacity = '.4';
      const res = await fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=${this.section}`);
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      ['CollectionResults', 'CollectionFacets', 'CollectionCount', 'ActiveFacets'].forEach((part) => {
        const id = `${part}-${this.section}`;
        const fresh = doc.getElementById(id);
        const cur = document.getElementById(id);
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      });
      if (target) target.style.opacity = '';
      window.history.replaceState({}, '', url);
    }
  }
  customElements.define('collection-filters', CollectionFilters);

  document.addEventListener('click', (e) => {
    const sw = e.target.closest('[data-layout-cols]');
    if (!sw) return;
    const grid = document.getElementById(sw.dataset.layoutTarget);
    if (!grid) return;
    grid.style.setProperty('--grid-cols', sw.dataset.layoutCols);
    $$('.layout-switch button', sw.closest('.collection-toolbar')).forEach((b) => b.classList.remove('is-active'));
    sw.classList.add('is-active');
  });

  /* ---------- Card swatch: swap image ---------- */
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('.product-card__swatches .swatch[data-swatch-image]');
    if (!sw) return;
    e.preventDefault();
    const card = sw.closest('.product-card');
    const img = $('.product-card__img--primary', card);
    if (img && sw.dataset.swatchImage) { img.src = sw.dataset.swatchImage; img.srcset = ''; }
    $$('.swatch', card).forEach((s) => s.classList.remove('is-active'));
    sw.classList.add('is-active');
  });

  /* ---------- Newsletter popup ---------- */
  class NewsletterPopup extends HTMLElement {
    connectedCallback() {
      if (window.location.pathname.includes('/challenge')) return;
      const key = 'aliour-newsletter-dismissed';
      const days = parseInt(this.dataset.frequency || '14', 10);
      const last = localStorage.getItem(key);
      if (last && Date.now() - parseInt(last, 10) < days * 864e5) return;
      if (window.Shopify && window.Shopify.designMode) return;
      setTimeout(() => {
        const modal = $('.modal', this);
        if (modal) { modal.classList.add('is-open'); getOverlay().classList.add('is-open'); }
      }, parseInt(this.dataset.delay || '6', 10) * 1000);
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-drawer-close]')) localStorage.setItem(key, String(Date.now()));
      });
    }
  }
  customElements.define('newsletter-popup', NewsletterPopup);

  /* ---------- Shopify section rendering (theme editor) ---------- */
  document.addEventListener('shopify:section:load', () => {
    $$('.reveal, .reveal-scale').forEach((el) => el.classList.add('is-inview'));
    relocateMenuDrawer();
  });
  document.addEventListener('shopify:section:select', (e) => {
    const modal = e.target.querySelector('.modal');
    if (modal) modal.classList.add('is-open');
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    const modal = e.target.querySelector('.modal');
    if (modal) modal.classList.remove('is-open');
  });
})();
